import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage, makeDataDangerous} from 'nutshell-core/utils/graphql-errors';

import type {
    GetSMSDashboard_inboxDashboard as SMSDashboard,
    GetSMSDashboard as GetSMSDashboardQuery,
    GetSMSDashboardVariables as GetSMSDashboardQueryVariables,
    DashboardInput,
} from 'nutshell-graphql-types';

import GET_SMS_DASHBOARD from '../queries/get-sms-dashboard.graphql';

export const useGetSMSDashboard = (
    input: DashboardInput
): {
    isLoading: boolean;
    errorMessage: string | null | undefined;
    smsDashboard: SMSDashboard;
} => {
    const {loading, data, error} = useQuery<GetSMSDashboardQuery, GetSMSDashboardQueryVariables>(
        GET_SMS_DASHBOARD,
        {
            variables: {input},
            notifyOnNetworkStatusChange: true,
        }
    );

    const {inboxDashboard} = makeDataDangerous(data);

    return {
        isLoading: loading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        smsDashboard: inboxDashboard,
    };
};
